import { PSYCHOLOGIST_ID } from 'constants/chat';
import { getUserId } from './storage';

export const isEmotionalSupport = getUserId() === PSYCHOLOGIST_ID;
